 <template>
  <div class="productCard">
    <div
      class="home_category"
      v-if="categoriesProduct"
      v-for="(category,index) in categoriesProduct"
      :key="index"
    >
      <div class="sub_heading flx">
        <h4>{{category.categoryDTO.categoryName}}</h4>
        <span
          class="see_all"
          @click="goToGetProductByCategory(category.categoryDTO.categoryId)"
        >{{$t('seeAll')}}</span>
      </div>
      <ul class="wrap_listing flx">
        <li
          v-for="(product,index) in category.saleProductDTOs.slice(0, 4)"
          :key="index"
          class="filter_card"
          :class="{'width100' : category.saleProductDTOs.length == 1}"
          @click="goToProductDetail(product.saleReferenceID)"
          style="flex-shrink:0"
        >
          <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage">
            <ImageSpinner class="image_spinner" />
            <img :data-url="product.displayImage" alt="product" />
          </div>
          <div class="product_detail">
            <div class="my_price_section">
              <span class="my_price">₹​ {{product.groupPrice}}</span>
              <span class="selling_price">₹​ {{product.markedPrice}}</span>
            </div>
            <p class="bought">
              {{product.peopleBought}}
              {{$t('peopleHaveBrought')}}
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- merchandise product list end here -->
    <div class="cntntLoad" v-if="cntntLoad">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import constant from "../../utils/constant";
import ImageSpinner from "../Common/ImageSpinner";
import { bus } from "../../main";
export default {
  name: "CategoriesProduct",
  components: {
    ImageSpinner
  },
  computed: {
    ...mapState(["saveCategoriesProduct"])
  },
  props: {
    categoriesProduct: {
      required: true,
      type: Array
    }
  },
  

  data() {
    return {
      trendingIndex: 0,
      categoryId: 0,
      cntntLoad: false
    };
  },

  methods: {
    getUserPrice(saleReferenceID, productDto) {
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(data => {
          productDto.sellingPrice = data.data.totalPaidAmount;
          this.cntntLoad = false;
        })
        .catch(err => {
          this.cntntLoad = false;
          productDto.sellingPrice = productDto.groupPrice;
          // let obj = {
          //   status: "Failure",
          //   timeoutMs: "5000"
          // };
          // bus.$emit("apiStatus", obj);
          console.log(err);
        });
    },
    goToGetProductByCategory(categoryId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push(
        "/product-by-category?type=NORMAL&categoryid=" + categoryId
      );
    },
    loadMore() {
      if (this.type == "TRENDING" && this.categoryId == 0) {
        this.getTrendingProducts();
      }
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
    getMerchandiseProducts(merchandiseId) {
      clevertap.event.push("merchandising_banner_click", {
        merchandiseId: merchandiseId
      });
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/merchandise-product-by-id/" + merchandiseId);
    }
  }
};
</script>